import React, { useMemo, useState } from 'react';
import { useRoute } from '@react-navigation/native';

import { GET_PURCHASE_ORDER } from '../../../common/graphql/purchaseOrder';
import { ROLE_PERMISSIONS } from '../../../common/constants';
import { useUserContext } from '../../../common/utils/context';

import { ActionDock, EmptyState, Screen } from '../../design/components';

import PurchaseOrderDetail from './PurchaseOrderDetail';

const PurchaseOrderDetailView = () => {
	const route = useRoute();
	const purchaseOrderId = route.params?.id;
	const { hasPermission } = useUserContext();
	// The child reports its primary action so it renders in the measured Screen dock.
	const [dockProps, setDockProps] = useState(null);

	const canAccessPurchaseOrderDetail = useMemo(() => {
		return Boolean(hasPermission(ROLE_PERMISSIONS.VIEW_PURCHASE_ORDER_DETAIL_PAGE));
	}, [hasPermission]);

	if (!canAccessPurchaseOrderDetail) {
		return (
			<Screen>
				<EmptyState icon="lock" title="You do not have access to this purchase order." />
			</Screen>
		);
	}

	if (!purchaseOrderId) {
		return (
			<Screen>
				<EmptyState title="No purchase order was selected." />
			</Screen>
		);
	}

	return (
		<Screen scroll={false} dock={dockProps ? <ActionDock hint={dockProps.hint} action={dockProps.action} /> : null}>
			<PurchaseOrderDetail
				id={purchaseOrderId}
				query={GET_PURCHASE_ORDER}
				onDockChange={setDockProps}
			/>
		</Screen>
	);
};

export default PurchaseOrderDetailView;
